<template>
  <svg fill="#000000" height="26" width="26" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
       viewBox="0 0 512 512" xml:space="preserve">
<g transform="translate(1 1)">
	<g>
		<g>
			<path d="M485.4,272.067h-59.733V24.6c0-14.507-11.093-25.6-25.6-25.6H24.6C10.093-1-1,10.093-1,24.6v435.2
				c0,28.16,23.04,51.2,51.2,51.2h409.6c28.16,0,51.2-23.04,51.2-51.2V297.667C511,283.16,499.907,272.067,485.4,272.067z
				 M50.2,493.933c-18.773,0-34.133-15.36-34.133-34.133V24.6c0-5.12,3.413-8.533,8.533-8.533h375.467
				c5.12,0,8.533,3.413,8.533,8.533v256v179.2c0,12.8,4.267,24.747,12.8,34.133H50.2z M493.933,459.8
				c0,18.773-15.36,34.133-34.133,34.133c-15.83,0-29.232-10.921-33.046-25.6h24.512c5.12,0,8.533-3.413,8.533-8.533
				c0-5.12-3.413-8.533-8.533-8.533h-25.6V434.2h42.667c5.12,0,8.533-3.413,8.533-8.533s-3.413-8.533-8.533-8.533h-42.667v-17.067
				h25.6c5.12,0,8.533-3.413,8.533-8.533c0-5.12-3.413-8.533-8.533-8.533h-25.6v-17.067h42.667c5.12,0,8.533-3.413,8.533-8.533
				s-3.413-8.533-8.533-8.533h-42.667v-59.733H485.4c5.12,0,8.533,3.413,8.533,8.533V459.8z"/>
      <path d="M374.467,84.333H50.2c-5.12,0-8.533,3.413-8.533,8.533v51.2c0,5.12,3.413,8.533,8.533,8.533h324.267
				c5.12,0,8.533-3.413,8.533-8.533v-51.2C383,87.747,379.587,84.333,374.467,84.333z M365.933,135.533h-307.2V101.4h307.2V135.533z
				"/>
      <path d="M374.467,41.667H50.2c-5.12,0-8.533,3.413-8.533,8.533s3.413,8.533,8.533,8.533h324.267c5.12,0,8.533-3.413,8.533-8.533
				S379.587,41.667,374.467,41.667z"/>
      <path d="M374.467,365.933h-51.2c-5.12,0-8.533,3.413-8.533,8.533v51.2c0,5.12,3.413,8.533,8.533,8.533h51.2
				c5.12,0,8.533-3.413,8.533-8.533v-51.2C383,369.347,379.587,365.933,374.467,365.933z M365.933,417.133H331.8V383h34.133V417.133
				z"/>
      <path d="M41.667,391.533c0,5.12,3.413,8.533,8.533,8.533h238.933c5.12,0,8.533-3.413,8.533-8.533c0-5.12-3.413-8.533-8.533-8.533
				H50.2C45.08,383,41.667,386.413,41.667,391.533z"/>
      <path d="M50.2,434.2h238.933c5.12,0,8.533-3.413,8.533-8.533s-3.413-8.533-8.533-8.533H50.2c-5.12,0-8.533,3.413-8.533,8.533
				S45.08,434.2,50.2,434.2z"/>
      <path d="M374.467,451.267H50.2c-5.12,0-8.533,3.413-8.533,8.533c0,5.12,3.413,8.533,8.533,8.533h324.267
				c5.12,0,8.533-3.413,8.533-8.533C383,454.68,379.587,451.267,374.467,451.267z"/>
      <path d="M161.133,357.4h102.4c5.12,0,8.533-3.413,8.533-8.533V301.08l2.56,2.56c1.707,1.707,3.413,2.56,5.973,2.56
				s4.267-0.853,5.973-2.56l25.6-25.6c1.707-1.707,2.56-3.413,2.56-5.973s-0.853-4.267-2.56-5.973l-93.867-93.867
				c-1.707-1.707-3.413-2.56-5.973-2.56c-2.56,0-4.267,0.853-5.973,2.56l-93.867,93.867c-3.413,3.413-3.413,8.533,0,11.947
				l25.6,25.6c1.707,1.707,3.413,2.56,5.973,2.56s4.267-0.853,5.973-2.56l2.56-2.56v47.787
				C152.6,353.987,156.013,357.4,161.133,357.4z M255,284.013v56.32h-85.333v-56.32l42.667-42.667L255,284.013z M144.067,285.72
				l-13.653-13.653l81.92-81.92l81.92,81.92L280.6,285.72l-11.092-11.092c0,0-0.001-0.001-0.001-0.001l-51.2-51.2
				c-0.853-1.707-2.56-2.56-4.267-2.56c0,0-0.853,0-1.707,0c-2.56,0-4.267,0.853-5.973,2.56l-51.2,51.2c0,0-0.001,0.001-0.001,0.001
				L144.067,285.72z"/>
		</g>
	</g>
</g>
</svg>
</template>
